Swiper.defaults.touchStartPreventDefault = false;
new Swiper(".your-hair_items-list", {
    slidesPerView: "auto",
    navigation: {
        nextEl: ".your-hair-swiper-button-next",
        prevEl: ".your-hair-swiper-button-prev",
    }
});
new Swiper(".indian-labs_items-list", {
    slidesPerView: "auto",
    navigation: {
        nextEl: ".indian-labs-swiper-button-next",
        prevEl: ".indian-labs-swiper-button-prev",
    }
});
new Swiper(".different-layers_items-list", {
    slidesPerView: 1,
    spaceBetween: 12,
    navigation: {
        nextEl: ".different-layers-swiper-button-next",
        prevEl: ".different-layers-swiper-button-prev",
    },
    breakpoints: {
        749: {
          slidesPerView: 3,
          spaceBetween: 24
        }
    }
});
new Swiper(".routine_block-items_list", {
    slidesPerView: "auto",
});

// new Swiper(".real-reactions_items-list", {
//     slidesPerView: "auto",
//     // navigation: {
//     //     nextEl: ".real-reactions_items-list-swiper-button-next",
//     //     prevEl: ".real-reactions_items-list-swiper-button-prev",
//     // }
// });
new Swiper('.real-reactions_items-list', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: true,
    grabCursor: true,
    loop: false,
    touchStartPreventDefault: false,
    passiveListeners: false,
    touchReleaseOnEdges: true,
    scrollbar: {
        enabled: false,
        el: null,
    },
});
new Swiper(".community_items-list", {
    slidesPerView: 1.2,
    spaceBetween: 15,
    breakpoints: {
        749: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
    },
    // navigation: {
    //     nextEl: ".real-reactions_items-list-swiper-button-next",
    //     prevEl: ".real-reactions_items-list-swiper-button-prev",
    // }
});

new Swiper(".related-blog-posts_items-list", {
    slidesPerView: "auto",
    navigation: {
        nextEl: ".related-blog-posts_items-list-swiper-button-next",
        prevEl: ".related-blog-posts_items-list-swiper-button-prev",
    }
});

new Swiper(".core-commitments_items-list", {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    initialSlide: 1,
    navigation: {
        nextEl: ".core-commitments-swiper-button-next",
        prevEl: ".core-commitments-swiper-button-prev",
    }
});

// new Swiper(".ibs-image-scrolling-item_list", {
//     slidesPerView: 1.5,
//     spaceBetween: 15,
//     centeredSlides: false,
//     loop: true,
//     breakpoints: {
//         749: {
//           slidesPerView: 4.5,
//           spaceBetween: 15,
//           centeredSlides: true,
//         }
//     }
// });

$('.product-meta-accodion_item-header').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parents('.product-meta-accodion_item').toggleClass('active');
    $(this).next().slideToggle('.product-meta-accodion_item-content');
});

$('.faq_item_title').click(function(){
   $(this).parents('.faq_item-wrapper').toggleClass('active');
    $(this).next().slideToggle();
});
new Swiper(".after-before_media-list", {
    slidesPerView: "auto",
    allowTouchMove: false,
    navigation: {
        nextEl: ".after-before-swiper-button-next",
        prevEl: ".after-before-swiper-button-prev",
    }
});

$(document).ready(function () {
$('.faq_view-all_button').on('click', function () {

    const $btn = $(this);
    const $wrapper = $btn.closest('.faq_wrapper');
    const $hiddenFaqs = $wrapper.find('.faq_item.default-hide');

   if ($btn.hasClass('expanded')) {

    const previousScroll = $(window).scrollTop();
    const previousHeight = $(document).height();

    $hiddenFaqs.removeClass('active');
    $btn.removeClass('expanded').text('View All');

    requestAnimationFrame(function () {
        const newHeight = $(document).height();
        const diff = previousHeight - newHeight;

        $(window).scrollTop(previousScroll - diff);
    });

} else {

    $hiddenFaqs.addClass('active');
    $btn.addClass('expanded').text('View Less');

}

});

  $('.rm-text_button').on('click', function () {
    $(this).parents('.rm-text_wrapper').find('.rm-text').toggle();

    // Toggle button text
    const $btn = $(this);
    if ($btn.text().trim() === 'read more') {
      $btn.text('read less');
    } else {
      $btn.text('read more');
    }
  });
  $('.mobile-menu_icon').on('click', function () {
   $('.mobile-menu_overlay').show();
   $('.mobile-menu').addClass('active');
   $('body').addClass('overflow-hidden-desktop');
  });
  $('.mobile-menu-close_icon').on('click', function () {
   $('.mobile-menu_overlay').hide();
   $('.mobile-menu').removeClass('active');
   $('body').removeClass('overflow-hidden-desktop');
  });

  $('.verified_block-item_description-text-read-more-less').on('click', function (e) {
    e.preventDefault();
   $(this).parents('.verified_block-item_description').find('.verified_block-item_description-text').toggle();
  });

  
});

// run this function only if draw line exists on the page
if($('.au-our-journey_wrapper').length) {
  $(".au-our-journey_wrapper .default-line").height($(".au-our-journey_wrapper").height());
  var items = $(".au-our-journey_item"),
  timelineHeight = $(".au-our-journey_wrapper").height(),
  greyLine = $('.default-line'),
  lineToDraw = $('.draw-line');
  // var liItem = $('.au-our-journey_item');
  
  // sets the height that the greyLine (.default-line) should be according to `.timeline ul` height
  
  $(window).on('scroll', function () {
    console.log('0000000000000000000')
    // Need to constantly get '.draw-line' height to compare against '.default-line'
    var redLineHeight = lineToDraw.height(),
    greyLineHeight = greyLine.height(),
    windowDistance = $(window).scrollTop(),
    windowHeight = $(window).height() / 1.5,
    timelineDistance = $(".au-our-journey_wrapper").offset().top;

    if(windowDistance >= timelineDistance - windowHeight) {
      line = windowDistance - timelineDistance + windowHeight;

      if(line <= greyLineHeight) {
        lineToDraw.css({
          'height' : line + 'px'
        });
      }
    }

    // This takes care of adding the class in-view to the li:before items
    var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
    
    items.each(function(index){
      var circlePosition = $(this).offset();
      if(bottom > circlePosition.top) {				
        $(this).addClass('in-view');
      } else {
        $(this).removeClass('in-view');
      }
    });
  });
}

// $(document).ready(function () {
  
//   const $featured_product_sticky = $('.featured-product-meta-buy_button');
//   if (!$featured_product_sticky.length) return;

//   let hasPassedOnce = false;
//   function checkScroll() {
//     const windowTop = $(window).scrollTop();
//     const featured_product_sticky_elBottom = $featured_product_sticky.offset().top + $featured_product_sticky.outerHeight();

//     // ✅ When scrolling DOWN past element
//     if (windowTop > featured_product_sticky_elBottom) {
//       $('.custom-sticky-featured-product').addClass('active');
//       hasPassedOnce = true;
//     }

//     // ✅ When scrolling BACK UP above element (after first pass only)
//     if (hasPassedOnce && windowTop <= featured_product_sticky_elBottom) {
//       $('.custom-sticky-featured-product').removeClass('active');
//     }
//   }

//   $(window).on('scroll', checkScroll);
// });
function stickyToggleOnScroll(triggerSelector, targetSelector) {
  const $trigger = $(triggerSelector);
  if (!$trigger.length) return;

  let hasPassedOnce = false;

  function checkScroll() {
    const windowTop = $(window).scrollTop();
    const triggerBottom = $trigger.offset().top + $trigger.outerHeight();

    // scrolling down past element
    if (windowTop > triggerBottom) {
      $(targetSelector).addClass('active');
      hasPassedOnce = true;
    }

    // scrolling back up (after first pass)
    if (hasPassedOnce && windowTop <= triggerBottom) {
      $(targetSelector).removeClass('active');
    }
  }

  $(window).on('scroll', checkScroll);

  // run once on load
  checkScroll();
}

$(document).ready(function () {
  stickyToggleOnScroll('.featured-product-meta-buy_button','.custom-sticky-featured-product');
  stickyToggleOnScroll('.product-meta-price-buy_button','.product-sticky_bar');
});